import { type NodeProps, type Node } from "@xyflow/react";
import type { HandleDirection } from "./handles";
import styles from "./WorkflowNode.module.css";

interface WorkflowGroupData {
  flowId: string;
  name: string;
  isEnabled?: boolean;
  direction?: HandleDirection;
  onRemove?: (flowId: string) => void;
  onChangeDirection?: (flowId: string, next: HandleDirection) => void;
}

const NEXT_DIRECTION: Record<HandleDirection, HandleDirection> = {
  TB: "LR",
  LR: "BT",
  BT: "TB",
};

const DIRECTION_GLYPH: Record<HandleDirection, string> = {
  TB: "↓",
  LR: "→",
  BT: "↑",
};

const DIRECTION_LABEL: Record<HandleDirection, string> = {
  TB: "Top to bottom",
  LR: "Left to right",
  BT: "Bottom to top",
};

export default function WorkflowGroupNode({ data }: NodeProps<Node>) {
  const d = data as unknown as WorkflowGroupData;
  const direction: HandleDirection = d.direction ?? "TB";
  return (
    <div className={styles.group}>
      <div className={styles.groupHeader}>
        <span
          className={`${styles.groupStatus} ${d.isEnabled ? styles.groupStatusOn : styles.groupStatusOff}`}
        />
        <span className={styles.groupTitle}>{d.name}</span>
        {d.onChangeDirection && (
          <button
            type="button"
            className={styles.groupDirection}
            onClick={(e) => {
              e.stopPropagation();
              d.onChangeDirection?.(d.flowId, NEXT_DIRECTION[direction]);
            }}
            title={`Layout: ${DIRECTION_LABEL[direction]} (click to rotate)`}
            aria-label={`Layout direction: ${DIRECTION_LABEL[direction]}`}
          >
            {DIRECTION_GLYPH[direction]}
          </button>
        )}
        {d.onRemove && (
          <button
            type="button"
            className={styles.groupRemove}
            onClick={(e) => {
              e.stopPropagation();
              d.onRemove?.(d.flowId);
            }}
            aria-label="Remove from canvas"
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
}
